import { Entity, PrimaryGeneratedColumn, Column, ManyToOne, JoinColumn, CreateDateColumn, UpdateDateColumn } from "typeorm"
import { PaygEvCharger } from "./PaygEvCharger"
import { PaygUser } from "./PaygUser"

@Entity("payg_transaction")
export class PaygTransaction {
    @PrimaryGeneratedColumn({ name: "id" })
    id?: number

    @ManyToOne(() => PaygEvCharger, charger => charger.transactions)
    @JoinColumn({ name: "iccid" })
    EvCharger?: PaygEvCharger

    @ManyToOne(() => PaygUser, user => user.transactions)
    @JoinColumn({ name: "user_id" })
    user?: PaygUser

    @Column()
    paymentId?: string

    @Column({ default: false })
    PaidStatus?: boolean

    @CreateDateColumn()
    createdAt?: Date

    @UpdateDateColumn()
    updatedAt?: Date

    @Column({ nullable: false })
    amount?: number

}

